import { ApiProperty } from "@nestjs/swagger";

export class EmployeeDeptRequest{
  @ApiProperty()
    employeeDept:string;
}